export default __webpack_public_path__ + "f871874c43f52cdc6a0e9b052bd87848.ttf";